import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  IColorOption,
  IRole,
} from '../../../app/features/roles-management/interfaces';

export interface RoleSelectionEvent {
  id?: string;
  userRole: IRole;
}
@Component({
  selector: 'app-role-info',
  imports: [MatIconModule],
  template: `
    <div
      [style.backgroundColor]="!noBackground() ? getBackgroundColor() : ''"
      [class.role-selected]="roleSelected()"
      [class.role-info__display-small]="smallAvatar()"
      class="role-info__display"
    >
      <mat-icon
        [style.backgroundColor]="
          icon() ? icon()?.background : role()?.icon?.background
        "
        [style.color]="icon() ? icon()?.color : role()?.icon?.color"
        [class.icon-big]="!smallAvatar()"
        [class.icon-small]="smallAvatar()"
        class="role-info__icon"
      >
        {{ role() ? role()?.icon?.name : roleName() }}
      </mat-icon>
      <div
        [style.color]="textColor()"
        [class.user-small]="smallAvatar()"
        class="role-info__user"
      >
        {{ roleName() ? roleName() : role()?.name }}
      </div>
      @if (roleSelected()) {
      <mat-icon [class.selected-menu]="forMenu()" class="role-info__check-icon"
        >check</mat-icon
      >
      }
    </div>
  `,
  styles: `
    @use "spacing/spacing-variables" as *;
    @use "mixins/mixins" as *;

    .role-info {
      &__display {
        position: relative;
        display: grid;
        grid-template-columns: auto 1fr auto;
        align-items: center;
        width: 100%;
        padding-left: $spacing-none !important;
        border-radius: var(--mat-sys-corner-small) !important;
        column-gap: $spacing-lg;
      }

      &__display-small {
        position: relative;
        display: grid;
        grid-template-columns: 1fr !important;
        align-items: center;
        width: 100%;
        padding-left: $spacing-none !important;
        border-radius: var(--mat-sys-corner-small) !important;
        column-gap: $spacing-lg;
      }

      &.role-selected {
        border-color: var(--mat-sys-extra-accent-green);
      }

      &__icon {
        z-index: 1;
        margin-right: $spacing-none !important;
        margin-left: $spacing-none !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        
        
        
        border-radius: var(--mat-sys-corner-small);
        background-color: var(--mat-sys-secondary-container);
      }
      &__user {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0.1px;
      }

      &__check-icon {
        color: var(--mat-sys-extra-accent-on-green);
        padding-right: $spacing-sm;
      }
    }


    .icon-big {
      width: $spacing-3xl !important;
      height: $spacing-3xl !important;
      font-size: 28px !important;
    }

    .icon-small {
      position: absolute;
      left: -8px;
      width: 21px !important;
      height: 21px !important;
      font-size: 20px !important;
      padding: $spacing-2xs;
      border-radius: 50%;
    }

    .user-small {
      margin-left: $spacing-xl;
    }
    .mdc-button {
      padding: $spacing-none !important;
      padding-right: $spacing-md !important;
    }

    .selected-menu {
      color: var(--mat-sys-on-surface);
      padding-right: $spacing-none;
      margin-right: $spacing-none;
    }

    .no-background {
      background-color: transparent !important;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleInfoComponent {
  role = input<Partial<IRole>>();
  roleName = input<string>('');
  roleSelected = input<boolean>(false);
  icon = input<IColorOption>();
  noBackground = input<boolean>(false);
  textColor = input<string>('var(--mat-sys-secondary)');
  forMenu = input<boolean>(false);
  smallAvatar = input<boolean>(false);

  protected getBackgroundColor(): string | undefined {
    if (this.noBackground()) return undefined;

    return this.roleSelected()
      ? 'var(--mat-sys-extra-accent-green-opacity-08)'
      : this.role()?.icon?.background;
  }
}
